import { styled, Typography } from '@mui/material';

function FicheRenseignementSuccess() {
    return (
        <Container>
            <Title variant="h1">Fiche de renseignements envoyée</Title>
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: theme.spacing(8),
    textAlign: 'center',
}));

const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export { FicheRenseignementSuccess };
